"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RelatedGuidesPromoBox;
var _react = _interopRequireDefault(require("react"));
var _reactComponents = require("@synerg/react-components");
require("../../shared/projects.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function RelatedGuidesPromoBox(_ref) {
  var projectIdEncrypted = _ref.projectIdEncrypted,
    projectName = _ref.projectName,
    sor = _ref.sor,
    caseId = _ref.caseId,
    filteredApis = _ref.filteredApis,
    history = _ref.history,
    projectApp = _ref.projectApp,
    disabled = _ref.disabled;
  var onNavigateToRelatedGuides = function onNavigateToRelatedGuides() {
    history.push("/projects/".concat(projectIdEncrypted, "/related-guides"), {
      projectIdEncrypted: projectIdEncrypted,
      projectName: projectName,
      sor: sor,
      caseId: caseId,
      filteredApis: filteredApis,
      projectApp: projectApp
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex height-promo-boxes flex-grow"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfPromoBox, {
    size: "sm",
    spacing: "default",
    className: "".concat(disabled ? 'gray-text' : ''),
    layout_lg: "horizontal",
    align: "left",
    variant: "".concat(disabled ? 'filled' : 'bordered'),
    header: "Related guides",
    message: "View related implementation guides associated with your project\u2019s use case.",
    "illustration-name": "".concat(disabled ? 'empty-clipboard' : 'clipboard')
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfLink, {
    className: "pb-2 mt-6",
    emphasis: "secondary",
    size: "sm",
    slot: "cta",
    disabled: disabled,
    onClick: onNavigateToRelatedGuides
  }, "View docs")));
}